import { useSalesPromoDetailGeneralInfo, useSubmitSummarySalesPromo } from "../../../providers/SalesPromo.provider"

export function useSalesPromoForm4(id?: string) {
    const submit = useSubmitSummarySalesPromo()
    const salesPromoDetail = useSalesPromoDetailGeneralInfo(id, true)

    return ({
      submit,
      salesPromoDetail,
    })
}